import React from "react";
import { Button, Typography } from "@mui/material";
import { VIEW_TYPES } from "../constants";
import { MOP_TYPES } from "../../../contants";
import { useTranslation } from "react-i18next";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import styles from "./overview.module.scss";

const MOP_IMAGES = {
  [MOP_TYPES.IMOPLITE]: "/assets/i-mop-lite_header.png",
  [MOP_TYPES.IMOPXL]: "/assets/i-mop-xl_001.png",
  [MOP_TYPES.IMOPXXL]: "/assets/i-mop-xxl_001.png",
};

function Overview({ mopType, viewSetter, currency, totalSavings }) {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <div className={styles.imageContainer}>
        <img alt="mop" src={MOP_IMAGES[mopType]} height="250px" width="auto" />
      </div>
      <Typography
        variant="h5"
        sx={{ textTransform: "uppercase" }}
        color="text.main"
      >
        {t("Your yearly labor & detergent savings")}
      </Typography>
      <Typography
        variant="h2"
        sx={{ fontWeight: 900, marginBottom: "1rem" }}
        color={"text.main"}
      >
        <span className={styles.currency}>{currency}</span>
        {totalSavings}
      </Typography>
      <Button
        variant="outlined"
        sx={{
          alignSelf: "center",
          padding: "2rem 2.3rem",
          height: "2.5em",
          fontSize: "16px",
          fontWeight: 700,
          borderRadius: "8px",
          borderColor: "button.details.normal.text",
          mb: "1em",
          "&:hover": {
            borderColor: "button.details.active.background",
            backgroundColor: "button.details.active.background",
            color: "button.details.active.text",
          },
        }}
        onClick={() => viewSetter(VIEW_TYPES.DETAILS)}
      >
        <div className={styles.buttonLegendContainer}>
          <Typography
            variant="body"
            sx={{ textTransform: "capitalize" }}
            color="button.details.normal.text"
          >
            {t("See full breakdown")}
          </Typography>
          <ArrowDownwardIcon
            color="arrowIcon"
            style={{ color: "button.details.normal.text" }}
          />
        </div>
      </Button>
    </>
  );
}

export default Overview;
